import AppProviders from '@app/AppProviders';
import AppRouter from '@app/AppRouter';
import '@hotam/component/styles.css';
import React from 'react';
import ReactDOM from 'react-dom/client';

import './styles.css';

ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(
  <React.StrictMode>
    <AppProviders>
      <AppRouter />
    </AppProviders>
  </React.StrictMode>,
);
